import { semanticColors, colorTokens } from "@/common/styles/colorTokens"
import styled from "styled-components"

export const MenuBar = styled.nav`
  position: relative;
  width: 100%;
  padding-bottom: 50px;
  background: ${semanticColors.background.primary};
`

export const MenuContainer = styled.div<{ $isCollapsed?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: ${props => props.$isCollapsed ? 'visible' : 'hidden'};
`

export const Header = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 60px;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
`

export const Logo = styled.div`
  position: relative;
  width: 136.59px;
  height: 30.13px;
  display: flex;
  align-items: center;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  padding: 0 19px;
  background: ${semanticColors.border.primary};
`

export const MainMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 6px;
  width: 100%;
  flex-grow: 1;
  padding: 20px 19px;
  overflow-y: auto;
`

export const MenuIcon = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
`

export const MenuLabel = styled.div.attrs({ className: 'subtitle2' })`
  font-size: 1rem;
  color: inherit;
  font-weight: 500;
  letter-spacing: -0.02em;
`

export const ArrowIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: inherit;
`

export const MenuItem = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isactive'
})<{ isactive: boolean, disabled?: boolean }>`
  position: relative;
  width: 100%;
  height: 44px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  background: ${props => props.isactive ? colorTokens.brand[100] : 'transparent'};
  border-radius: 10px;
  cursor: pointer;
  color: ${props => props.isactive ? colorTokens.brand[600] : colorTokens.gray[900]};
  transition: all 0.15s ease;

  &:hover {
    background: ${props => props.isactive ? colorTokens.brand[100] : colorTokens.gray[100]};
    color: ${props => props.isactive ? colorTokens.brand[700] : colorTokens.gray[900]};

    ${MenuLabel}, ${MenuIcon}, ${ArrowIcon} {
      color: inherit;
    }
  }

  ${props => props.disabled && `
    cursor: not-allowed;
    opacity: 0.5;
  `}
`

export const SubMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  width: 100%;
  margin-left: 40px;
`

export const SubMenuItem = styled(MenuItem)<{ disabled?: boolean }>`
  padding: 12px 14px;
  width: calc(100% - 40px);
  justify-content: flex-start;
  gap: 14px;
`

export const SubMenuWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isopen', 'menuCount'].includes(prop)
})<{ isopen: boolean, menuCount: number }>`
  width: 100%;
  overflow: hidden;
  min-height: ${props => props.isopen ? `${props.menuCount * 44}px` : '0'};
  max-height: ${props => props.isopen ? `${props.menuCount * 44}px` : '0'};
  opacity: ${props => props.isopen ? 1 : 0};
  transition: all 0.3s ease-in-out;
`

